var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import Runtime from './runtime';
import compile from 'idyll-compiler';

export var hashCode = function hashCode(str) {
  var hash = 0,
      i,
      chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

var IdyllDocument = function (_React$Component) {
  _inherits(IdyllDocument, _React$Component);

  function IdyllDocument(props) {
    _classCallCheck(this, IdyllDocument);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      ast: props.ast || [],
      previousAST: props.ast || [],
      hash: '',
      error: null
    };
    return _this;
  }

  IdyllDocument.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.props.ast && this.props.markup) {
      compile(this.props.markup, this.props.compilerOptions).then(function (ast) {
        _this2.setState({ ast: ast, hash: hashCode(_this2.props.markup), error: null });
      });
    }
  };

  IdyllDocument.prototype.componentDidCatch = function componentDidCatch(error, info) {
    this.props.onError && this.props.onError(error);
    this.setState({ error: error.message });
  };

  IdyllDocument.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this3 = this;

    if (newProps.ast) {
      return;
    }

    var hash = hashCode(newProps.markup);
    if (hash !== this.state.hash) {
      this.setState({ previousAST: this.state.ast });
      compile(newProps.markup, newProps.compilerOptions).then(function (ast) {
        _this3.setState({ previousAST: ast, ast: ast, hash: hash, error: null });
      }).catch(this.componentDidCatch.bind(this));
    }
  };

  IdyllDocument.prototype.getErrorComponent = function getErrorComponent() {
    if (!this.state.error) {
      return null;
    }
    return React.createElement(this.props.errorComponent || 'pre', {
      className: "idyll-document-error"
    }, this.state.error);
  };

  IdyllDocument.prototype.render = function render() {
    var _this4 = this;

    return React.createElement(
      'div',
      null,
      React.createElement(Runtime, _extends({}, this.props, {
        key: this.state.hash,
        context: function context(_context) {
          _this4.idyllContext = _context;
          typeof _this4.props.context === 'function' && _this4.props.context(_context);
        },
        initialState: this.props.initialState || (this.idyllContext ? this.idyllContext.data() : {}),
        ast: this.props.ast || this.state.ast
      })),
      this.getErrorComponent()
    );
  };

  return IdyllDocument;
}(React.Component);

export default IdyllDocument;


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-document/dist/es/index.js
// module id = 927
// module chunks = 0